import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  App,
  Button,
  Card,
  Dropdown,
  Flex,
  Input,
  Popconfirm,
  Popover,
  Space,
  Table,
  Tag,
  Tooltip,
} from 'antd';
import React, { useRef, useState } from 'react';
import { queryKeys } from '../../services/react-query/queryKeys';
import { MdDelete, MdModeEditOutline, MdSubtitles } from 'react-icons/md';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import StatusTag from '../../hooks/StatusHook';
import { useNavigate } from 'react-router-dom';
import { RiUserLocationFill } from 'react-icons/ri';
import {
  cancelMaterialRequest,
  submitMaterialRequest,
} from '../../network/materialRequest';
import { TiCancel } from 'react-icons/ti';
import {
  deleteExpenseClaimSubmit,
  getExpenseClaimSubmit,
} from '../../network/expenseClaimSubmit';
import PropsSearchTable from '../../components/common/PropsSearchTable/PropsSearchTable';
import { deleteSalarySlip, getSalarySlip } from '../../network/salarySlip';
import {
  deleteCustomer,
  getCustomer,
  getCustomerListDetails,
} from '../../network/customer';
import { PiDotsThreeVerticalBold } from 'react-icons/pi';
import { IoIosArrowRoundBack, IoIosArrowRoundForward } from 'react-icons/io';
import { useSelector } from 'react-redux';
import DashboardCards from '../Dashboard/DashboardCards';
const CustomerList = ({ t }) => {
  const navigate = useNavigate();
  const client = useQueryClient();
  const { currentLang } = useSelector((state) => state.user);
  const { message } = App.useApp();
  const searchInput = useRef(null);
  const searchInputMobile = useRef(null);
  const [textValue, setTextValue] = useState('');
  const [searchText, setSearchText] = useState({
    value: '',
    key: '',
  });
  const handleSearch = (selectedKeys, confirm, key) => {
    confirm();
    // console.log(`Searching for: ${selectedKeys[0]}, key: ${key}`);
    setSearchText({ value: selectedKeys[0], key });
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    setSearchText({ value: '', key: '' });
  };
  const props = ({ key, name }) =>
    PropsSearchTable({
      key: key,
      name: name,
      setTextValue: setTextValue,
      textValue: textValue,
      setSearchText: setSearchText,
      searchInputMobile: searchInputMobile,
      searchInput: searchInput,
      handleSearch: handleSearch,
      handleReset: handleReset,
      t: t,
    });
  const handleRemove = useMutation({
    mutationFn: (id) => deleteCustomer(id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message ? data?.message : 'Deleted successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getCustomer] });
    },
    onError: () => {
      // message.error('Something went wrong');
    },
  });

  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getCustomer, searchText.key, searchText.value],
    queryFn: () =>
      getCustomer({
        key: searchText.key,
        value: searchText.value,
      }),
    keepPreviousData: true,
  });
  const items = (record) => [
    // {
    //   key: 'details',
    //   label: (
    //     <span className="flex items-center gap-2 text-[#818181] font-[700] text-[14px]">
    //       <EyeOutlined />
    //       {t.details} {t.customer}
    //     </span>
    //   ),
    //   onClick: () => {
    //     navigate(`/course-details/${record?.Id}`);
    //   },
    // },
    {
      key: 'edit',
      label: (
        <span className="flex items-center gap-2 text-[#818181] font-[700] text-[14px]">
          <EditOutlined />
          {t.edit} {t.customer}
        </span>
      ),
      onClick: () => {
        navigate(`/customers/edit/${record?.name}`);
      },
    },
    {
      key: 'address',
      label: (
        <span className="flex items-center gap-2 text-[#818181] font-[700] text-[14px]">
          <RiUserLocationFill />
          {t.addAddress}
        </span>
      ),
      onClick: () => {
        navigate(`/address?open=true&customer=${record?.name}`);
      },
    },
    {
      key: 'delete',
      danger: true,
      label: (
        <Popconfirm
          // placement="left"
          title={t.delete}
          description={t.deleteMessageCourse}
          onConfirm={() => handleRemove.mutate(record?.name)}
          okText={t.yes}
          cancelText={t.no}
          okType="danger"
        >
          <span className="flex items-center gap-2  font-[700] text-[14px]">
            <DeleteOutlined />
            {t.delete} {t.customer}
          </span>
        </Popconfirm>
      ),
    },
  ];
  const columns = [
    {
      title: `# ${t.id}`,
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: t.customerName,
      dataIndex: 'customer_name',
      key: 'customer_name',
      ...props({ key: 'customer_name', name: t.customerName }),
    },
    {
      title: t.customerGroup,
      dataIndex: 'customer_group',
      key: 'customer_group',
      ...props({ key: 'customer_group', name: t.customerGroup }),
    },
    {
      title: t.customerType,
      dataIndex: 'customer_type',
      key: 'customer_type',
      ...props({ key: 'customer_type', name: t.customerType }),
    },
    {
      title: t.territory,
      dataIndex: 'territory',
      key: 'territory',
      ...props({ key: 'territory', name: t.territory }),
    },
    {
      title: t.email,
      dataIndex: 'custom_email',
      key: 'custom_email',
      ...props({ key: 'custom_email', name: t.email }),
      render: (text) => <a href={`mailto:${text}`}>{text}</a>,
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      width: 100,
      render: (text, record) => {
        return (
          // <Space>
          //   <Button
          //     size="small"
          //     type="primary"
          //     onClick={() => {
          //       navigate(`/customers/edit/${record?.name}`);
          //     }}
          //     icon={<MdModeEditOutline />}
          //   />
          //   <Tooltip title={t.addAddress}>
          //     <Button
          //       size="small"
          //       type="primary"
          //       style={{
          //         backgroundColor: '#2F80ED',
          //       }}
          //       onClick={() => {
          //         navigate(`/address?open=true&customer=${record?.name}`);
          //       }}
          //       icon={<RiUserLocationFill />}
          //     />
          //   </Tooltip>
          //   <Popconfirm
          //     title={t.deleteCustomer + ` (${record?.name})`}
          //     description={t.areYouSure}
          //     onConfirm={() => handleRemove.mutate(record?.name)}
          //     okText={t.yes}
          //     cancelText={t.no}
          //   >
          //     <Button size="small" type="primary" danger icon={<MdDelete />} />
          //   </Popconfirm>
          // </Space>
          <Dropdown
            menu={{ items: items(record) }}
            // placement="bottomRight"
            overlayClassName="custom-dropdown"
            trigger={['click']}
          >
            <Button
              type="text"
              icon={<PiDotsThreeVerticalBold size={20} color="#86888C" />}
            />
          </Dropdown>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => {
    return {
      key: index,
      ...item,
      id: index + 1,
    };
  });
  return (
    <div className="inventory">
      <DashboardCards t={t} />
      {/* <Heading title={t.HR} subTitle={t.salarySlip} path="/" /> */}
      <Card className="mt-5">
        <Flex
          style={{
            width: '100%',
            marginBottom: 16,
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
          wrap
        >
          <Input.Search
            placeholder={t.searchByName}
            onSearch={(value) => setSearchText(value)}
            onChange={(value) => setSearchText(value.target.value)}
            style={{ width: 200 }}
            allowClear
            className="search-input-ant"
            // className="form-control"
            prefix={<SearchOutlined />}
          />
          <Button
            type="primary"
            onClick={() => {
              navigate('/customers/add');
            }}
          >
            <PlusOutlined
              style={{
                fontSize: '10px',
              }}
            />
            {t.addCustomer}
          </Button>
        </Flex>
        <Table
          className="table_custom"
          columns={columns}
          dataSource={dataTable}
          loading={isLoading}
          setSearchText={setSearchText}
          scroll={{ x: 'max-content' }}
          pagination={{
            pageSize: 10,
            // current: pageCount,
            // total: totalPages,
            hideOnSinglePage: true,
            showSizeChanger: false,
            // align: 'center',
            itemRender: (current, type, originalElement) => {
              if (type === 'prev') {
                return (
                  <div
                    // onClick={handlePrevClick}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                      order: 1,
                    }}
                  >
                    <IoIosArrowRoundForward
                      size={16}
                      style={{
                        transform:
                          currentLang === 'en'
                            ? 'rotate(180deg)'
                            : 'rotate(0deg)',
                      }}
                    />
                    <span>{t.prev}</span>
                  </div>
                );
              }
              if (type === 'next') {
                return (
                  <div
                    // onClick={handleNextClick}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                      order: -1,
                    }}
                  >
                    <span> {t.next}</span>
                    <IoIosArrowRoundBack
                      size={16}
                      style={{
                        transform:
                          currentLang === 'en'
                            ? 'rotate(180deg)'
                            : 'rotate(0deg)',
                      }}
                    />
                  </div>
                );
              }
              return originalElement;
            },
            // onChange: (page) => {
            //   setFilterData({ ...filterData, page });
            // },
          }}
        />
      </Card>
    </div>
  );
};

export default CustomerList;
